/**
 * Heatmap component
 */

/** Dependencies -------------------------------------------- */

// External

// Internal

import { getPlugin, developmentLevels } from '../dictionary'
import { useAppState } from '../state'

import Mapbox from './mapbox'
import Button from './button'
import Icon from './icon'
import Tooltip from './tooltip'

/** Main ---------------------------------------------------- */

const baseClassName = 'heatmap'

const toolButtonProps = {
    layout             : 'circular',
    theme              : 'primary',
    isScreenReaderOnly : true
}

export default function Heatmap() {

    // Constants

    const plugin = getPlugin()

    const setHasPreamble = useAppState( ( state ) => state.setHasPreamble )

    const zoomIn = useAppState( ( state ) => state.zoomIn )
    const zoomOut = useAppState( ( state ) => state.zoomOut )

    // Handlers

    function handleShowDisclaimer() {
        setHasPreamble( true )
    }

    return (

        <div className={ baseClassName }>

            <div className={ `${baseClassName}__inner` }>

                <Mapbox/>

                <div className={ `${baseClassName}__ui` }>

                    <ul className={ `${baseClassName}__map-controls` }>
                        <li className={ `${baseClassName}__map-control` }>
                            <Button title="Zoom in" leadingIconProps={ { type: 'plus' } } data-tooltip-id="heatmap-zoom-in" onClick={ zoomIn } { ...toolButtonProps }/>
                            <Tooltip id="heatmap-zoom-in" place="right">Zoom in</Tooltip>
                        </li>
                        <li className={ `${baseClassName}__map-control` }>
                            <Button title="Zoom out" leadingIconProps={ { type: 'minus' } } data-tooltip-id="heatmap-zoom-out" onClick={ zoomOut } { ...toolButtonProps }/>
                            <Tooltip id="heatmap-zoom-out" place="right">Zoom out</Tooltip>
                        </li>
                    </ul>

                    <ul className={ `${baseClassName}__general-controls` }>
                        <li className={ `${baseClassName}__general-control` }>
                            <Button
                                title="Show disclaimer"
                                leadingIconProps={ { type: 'info' } }
                                data-tooltip-id="heatmap-show-disclaimer"
                                onClick={ handleShowDisclaimer }
                                { ...toolButtonProps }
                            />
                            <Tooltip id="heatmap-show-disclaimer" place="right">Show disclaimer</Tooltip>
                        </li>
                        <li className={ `${baseClassName}__general-control` }>
                            <Button
                                title="Download all data as JSON"
                                link={ plugin.dataUrl }
                                leadingIconProps={ { type: 'downloadCloud' } }
                                download={ true }
                                data-tooltip-id="heatmap-download-all"
                                target="_blank"
                                { ...toolButtonProps }
                            />
                            <Tooltip id="heatmap-download-all" place="right">Download all data as JSON</Tooltip>
                        </li>
                    </ul>

                    {/* <figcaption className={ `${baseClassName}__development-level-legend` }>
                        <span className={ `${baseClassName}__development-level-header` }>
                            <span className={ `${baseClassName}__development-level-title` }>Development Levels</span>
                            <Button
                                title="Election Development Level"
                                link={ plugin.methodologyUrl }
                                type="naked"
                                size="sm"
                                leadingIconProps={ { type: 'info' } }
                                isScreenReaderOnly={ true }
                                data-tooltip-id="heatmap-development-level-info"
                                target="_blank"
                                className={ `${baseClassName}__development-level-info` }
                            />
                            <Tooltip id="heatmap-development-level-info" >See our methodology</Tooltip>
                        </span>
                        <dl className={ `${baseClassName}__development-level-list` }>
                            { developmentLevels.map( ( developmentLevel ) => (
                                <dt key={ developmentLevel.id } className={ `${baseClassName}__development-level is-level-${developmentLevel.id}` }>
                                    { developmentLevel.numericValue }
                                </dt>
                            ) ) }
                        </dl>
                    </figcaption> */}

                </div>

            </div>

        </div>
    )
}
